/**
 * @typedef {import("@prismicio/client").Content.TextOnlySlice} TextOnlySlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TextOnlySlice>} TextOnlyProps
 * @type {import("react").FC<TextOnlyProps>}
 */
import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";

const TextOnly = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-bleu-50 text-bleu-950"
    >
      <div className="framing padding-y padding-x flex flex-col gap-2">
        {isFilled.richText(slice.primary.text) && (
          <PrismicRichText
            field={slice.primary.text}
            components={{
              heading1: ({ children }) => <h1 className="h2 first:mt-0 mt-12 mb-4">{children}</h1>,
              heading2: ({ children }) => <h2 className="h3 mt-10 mb-2">{children}</h2>,
              heading3: ({ children }) => <h3>{children}</h3>,
              paragraph: ({ children }) => <p>{children}</p>,
              strong: ({ children }) => <strong>{children}</strong>,
              em: ({ children }) => <em>{children}</em>,
              hyperlink: ({ children, node }) => (
                <a
                  href={node.data?.url}
                  target={node.data?.target}
                  rel={node.data?.target === "_blank" ? "noreferrer" : undefined}
                  className="underline underline-offset-2"
                >
                  {children}
                </a>
              ),
              listItem: ({ children }) => <li className="list-disc list-inside body-s">{children}</li>,
            }}
          />
        )}
      </div>
    </section>
  );
};

export default TextOnly;
